import React from "react";
import useForm from "./index";
import Label from "./label";
import { TForm, TInputElementProps, TInputProps } from "@/components/form/types";

export const DateInput = ({ container, input, label, tooltip, className, hidden, options }: TInputElementProps<TDateInput>) => {
    const click = () => {
        const element = document.getElementById(input?.id);
        if (element) { // @ts-ignore
            element.showPicker();
        }
    }

    if (hidden) {
        return null;
    }

    return (
        <div {...container} className={container?.className ?? className}>
            <Label {...label} tooltip={tooltip} options={options}/>
            <input {...input} onClick={click}/>
        </div>
    );
};

type TDateInput = string;
const useDateInput = <T extends TDateInput>(props: TInputProps<T>): TForm<TDateInput> => {
    const form = useForm<TDateInput>({
        id: "date",
        type: "date",
        default: "",
        ...props,
    })

    return {
        ...form,
    }
}

export default useDateInput;
